import { createContext, useContext } from 'react'

import type { UserPermissions } from 'tripPlanner/types/common'

export interface TripContextValue {
  tripId: string
  isPublicTrip: boolean
  permissions: UserPermissions
  name: string
  startDate?: moment.Moment
  endDate?: moment.Moment
  displayContext: 'savedItemsDrawer' | 'tripPlanner' | 'homepage' | 'search'
}

const TripContext = createContext<TripContextValue | null>(null)

export const useTripId = () => useContext(TripContext)?.tripId ?? ''

export default TripContext
